import { ExportResultCode, hrTimeToMilliseconds } from '@opentelemetry/core';
import { ConsoleSpanExporter } from '@opentelemetry/sdk-trace-base';

// For consistency with Rhumb: https://github.com/HubSpotEngineering/react-rhumb/blob/b0e4ff756910ff4ba76c52736615bc68c0d3e4ff/react-rhumb/static/js/internal/reporters/BaseReporter.ts#L213
const labelCss = (background, border) => {
  return `background-color:${background};color:black;padding: 0 .5rem;border-left: 4px solid ${border};`;
};
const summarize = names => {
  if (names.size === 0) return null;
  const toShow = Array.from(names).slice(0, 3);
  return `${toShow.join(', ')} ${names.size > 3 ? `+ ${names.size - 3} more` : ''}`;
};
const enrich = span => Object.assign({}, span, {
  durationMs: hrTimeToMilliseconds(span.duration),
  attributeNames: summarize(new Set(Object.keys(span.attributes))),
  instrumentation: span.instrumentationScope.name
});
const TABLE_COLUMNS = ['name', 'instrumentation', 'durationMs', 'attributeNames'];
const writeTable = spans => console.table(Object.fromEntries(spans.map(span => [span.spanContext().spanId, enrich(span)])), TABLE_COLUMNS);
export class DevConsoleSpanExporter extends ConsoleSpanExporter {
  export(spans, resultCallback) {
    if (process.env.NODE_ENV === 'production') {
      super.export(spans, resultCallback);
    } else {
      const spanNames = new Set(spans.map(span => span.name));
      console.groupCollapsed(`%cOpenTelemetry%c Spans logged: ${summarize(spanNames)}`, labelCss('lightgrey', 'blue'), '');
      writeTable(spans);
      console.groupEnd();
      resultCallback({
        code: ExportResultCode.SUCCESS
      });
    }
  }
}